import {Pipe, PipeTransform} from '@angular/core';
@Pipe({
  name: 'mapToIterable'
})
export class MapToIterable implements PipeTransform {
  transform(dict: Map<any, any>): Array<any> {
    const a = [];
    dict.forEach((value, key) => {
      a.push({key: key, value: dict.get(key)});
    });
    console.log(a);
    return a;
  }
}



// WEBPACK FOOTER //
// ./src/app/map-to-iterable.pipe.ts